const TRANSFER_PREFIX_RE = /^\[transfer:([A-Z]{1,3})\] /;

export function parseTransferNotification(
  body: string
): { senderInitials: string } | null {
  const match = body.match(TRANSFER_PREFIX_RE);
  if (!match) return null;
  return { senderInitials: match[1] };
}
